import { createStore, applyMiddleware, compose } from 'redux'
import { serviceMiddleware } from 'reservice'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { createBrowserHistory, createMemoryHistory } from 'history'

// A nice helper to tell us if we're on the server
export const isServer = !(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)

// Create a history depending on the environment
export const history = isServer
  ? createMemoryHistory({
    initialEntries: ['/']
  })
  : createBrowserHistory()

const configureStore = ({
  rootReducer,
  preloadedState,
  middlewares,
  hotReloadName
}) => {
  let store
  let composeEnhancers = compose

  const enhancer = applyMiddleware(
    serviceMiddleware,
    routerMiddleware(history), // for dispatching history actions
    ...middlewares
  )

  if (process.env.NODE_ENV === 'development') {
    const isEnableReduxTrace = (process.env.REDUX_TRACE === 1)
    if (global.window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      composeEnhancers = isEnableReduxTrace
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true })
        : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
    store = createStore(
      connectRouter(history)(rootReducer), // new root reducer with router state
      preloadedState,

      composeEnhancers(
        enhancer
      )
    )

    if (module.hot && hotReloadName) {
      // Enable Webpack hot module replacement for reducers
      module.hot.accept('./reducers', () => {
        // store.replaceReducer(require('./reducers/index').default)
        store.replaceReducer(connectRouter(history)(rootReducer))
      })
    }
  } else {
    store = createStore(
      connectRouter(history)(rootReducer), // new root reducer with router state
      preloadedState,
      enhancer
    )
  }
  return store
}

export default configureStore
